import React from 'react'

export default function ExportAfterPayForPayAsUse() {
  return (
    <>
      <h2>Try before you use</h2>
    </>
  )
}
